import { Route } from "@angular/router";
import { DeliveryDetailsComponent } from "./delivery-details.component";
import { ListCabResolver } from "../shared/delivery-details/list-cab.resolver";
import { ArticleGeneriqueResolver } from "../shared/delivery-details/article.resolver";

export const DeliveryDetailsRouting: Route = {
  path: ':date/:code_article',
  component: DeliveryDetailsComponent,
  outlet: 'sidebar',
  resolve:{
    listCab : ListCabResolver,
    article: ArticleGeneriqueResolver
  },
  data: {
    breadcrumb: "Details"
  }
};
